import { render, staticRenderFns } from "./fontRight.vue?vue&type=template&id=39083d06&scoped=true"
import script from "./fontRight.vue?vue&type=script&lang=js"
export * from "./fontRight.vue?vue&type=script&lang=js"
import style0 from "./fontRight.vue?vue&type=style&index=0&id=39083d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39083d06",
  null
  
)

export default component.exports